import Content from "components/Content";
import Label from "components/Label";
import React, { FC } from "react";
import Team from "../../../../../public/team.png";

import styles from "./styles.module.scss";
import { objectives } from "./constants";

const OurMission: FC = () => {
  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <img src={Team.src} alt="" className={styles.team} />
      <Label className={styles.title} variant="h2" color="primary2">
        Our values
      </Label>
      <div className={styles.objectives}>
        {objectives.map(({ title, description, Icon }) => (
          <div className={styles.objective}>
            <Icon className={styles.icon} />
            <Label variant="h4" color="primary2">
              {title}
            </Label>
            <Label variant="s3" color="primary2">
              {description}
            </Label>
          </div>
        ))}
      </div>
    </Content>
  );
};

export default OurMission;
